import type { JSX } from 'react';
import type { TakiConfig } from '@taki/runtime-config';
import { SettingsInfo, SettingsPanel, SettingsRow, SettingsSection } from '@taki/ui';
import type { ShellAppEntry } from '../types.js';
import { SectionsLia } from './IaSettingsPanel.js';

/**
 * L'id de l'app Canaux, la messagerie par canaux du centre de communication.
 * Le shell la nomme deja (source `canaux` du centre) ; ici, seulement pour
 * signaler sa presence et renvoyer vers ses reglages propres.
 */
const CANAUX_APP_ID = 'canaux';

/**
 * PARAMETRES > CONVERSATIONS (`/settings?t=conversations`, ex-onglet « IA »,
 * renomme le 06/10/2026 a la demande du fondateur) : tout ce qui parle, au
 * meme endroit. Trois temps, dans cet ordre :
 *
 *   1. Canaux : un renvoi vers l'app. Ses reglages et l'import de demonstration
 *      restent dans son propre onglet de parametres.
 *   2. Fenetre de chat : le lanceur de Lia (mascotte ou bulle).
 *   3. Lia : acces et modele, WhatsApp, assistant externe, connexions MCP.
 *
 * Chaque section dit dans sa phrase si elle vaut pour l'ORGANISATION (owner)
 * ou pour SOI : l'onglet melange les deux, et c'est la phrase qui les separe.
 */
export function ConversationsSettingsPanel({
  appEntries,
  config,
}: {
  appEntries: readonly ShellAppEntry[];
  config: TakiConfig;
}): JSX.Element {
  const canaux = appEntries.find((entry) => entry.id === CANAUX_APP_ID);
  return (
    <SettingsPanel>
      <SettingsSection title="">
        {canaux === undefined ? <SettingsInfo>Canaux : app non installée.</SettingsInfo> :
          <SettingsRow label="Canaux"><a href="/settings?t=app%3Acanaux" className="text-sm text-ink-700 underline">Réglages de l’app</a></SettingsRow>}
      </SettingsSection>
      <SectionsLia config={config} />
    </SettingsPanel>
  );
}
